import { ProductScreenshot } from 'components/ProductScreenshot';
import { ProductVideo } from 'components/ProductVideo';
import ImgTrendsLight from "../../../../contents/images/docs/product-analytics/trends-light.png";
import ImgTrendsDark from "../../../../contents/images/docs/product-analytics/trends-dark.png";
import ImgFunnelLight from "../../../../contents/images/docs/product-analytics/funnel-light.png";
import ImgFunnelDark from "../../../../contents/images/docs/product-analytics/funnel-dark.png";
import ImgRetentionLight from "../../../../contents/images/docs/product-analytics/retention-light.png";
import ImgRetentionDark from "../../../../contents/images/docs/product-analytics/retention-dark.png";
import ImgUserPathsLight from "../../../../contents/images/docs/product-analytics/user-paths-light.png";
import ImgUserPathsDark from "../../../../contents/images/docs/product-analytics/user-paths-dark.png";
import ImgStickinessLight from "../../../../contents/images/docs/product-analytics/stickiness-light.png";
import ImgStickinessDark from "../../../../contents/images/docs/product-analytics/stickiness-dark.png";
import ImgLifecycleLight from "../../../../contents/images/docs/product-analytics/lifecycle-light.png";
import ImgLifecycleDark from "../../../../contents/images/docs/product-analytics/lifecycle-dark.png";
import ImgSQLLight from "../../../../contents/images/docs/product-analytics/sql-light.png";
import ImgSQLDark from "../../../../contents/images/docs/product-analytics/sql-dark.png";
import NewInsightLight from "../../../../contents/images/docs/product-analytics/creating-an-insight-light.mp4";
import NewInsightDark from "../../../../contents/images/docs/product-analytics/creating-an-insight-dark.mp4";
import * as React from 'react';
export default {
  ProductScreenshot,
  ProductVideo,
  ImgTrendsLight,
  ImgTrendsDark,
  ImgFunnelLight,
  ImgFunnelDark,
  ImgRetentionLight,
  ImgRetentionDark,
  ImgUserPathsLight,
  ImgUserPathsDark,
  ImgStickinessLight,
  ImgStickinessDark,
  ImgLifecycleLight,
  ImgLifecycleDark,
  ImgSQLLight,
  ImgSQLDark,
  NewInsightLight,
  NewInsightDark,
  React
};